export enum WellknownAgreementType {
    ADYEN_POS = "ADYEN_POS",
}

export enum AgreementStatus {
    AWAITING_T_AND_C = "AWAITING_T_AND_C",
    CREATE_BUSINESS_LINES = "CREATE_BUSINESS_LINES",
    START = "START",
    PENDING = "PENDING",
    INVALID = "INVALID",
    VALID = "VALID",
    REJECTED = "REJECTED",
}
export type AgreementStatusVariant = AgreementStatus

// Acquirers LIST
export type AgreementType = WellknownAgreementType.ADYEN_POS | string

export type Acquirer = Readonly<{
    id: number
    displayName: string
    agreementTypes: AgreementType[]
}>

// Acquirer agreement

export type ActionDetails = Readonly<{
    externalUrl: string
}>

type AcquirerAgreementDetails = Readonly<{
    acquirer: Pick<Acquirer, "id" | "displayName">
    status: AgreementStatus
    actionDetails?: ActionDetails
}>

export type Agreement = Readonly<{
    id: number
    type: AgreementType
    supplier: {
        id: number
    }
    termsAndConditions: {
        accepted: boolean
    }
    adyenAgreement?: AcquirerAgreementDetails
}>

// Bank accounts + Industry codes

export enum BankAccountStatus {
    PENDING = "PENDING",
    INVALID = "INVALID",
    REJECTED = "REJECTED",
    VALID = "VALID",
}

export type MerchantDetails = Readonly<{
    id: number
    regNumber: string
    name: string
}>

export type IndustryCode = Readonly<{
    id: string
    code: string
    description: string
    refId: string
}>

export type CreateIndustryCodeBody = Readonly<{
    supplier: {
        id: number
    }
    code: string
}>

export type BankAccount = Readonly<{
    id: string
    bankName: string
    accountIdentifier: string
    status: BankAccountStatus
    merchant?: MerchantDetails
    refId: string
}>

export type IndustryCodeChoice = Readonly<{
    code: string
    description: string
    requiresApproval: boolean
}>
